const data = [{
        "content": "Ning Chen, Tie Qiu, Zilong Lu, Dapeng Oliver Wu. An adaptive robustness evolution algorithm with self-competition and Its 3D deployment for Internet of Things. <strong style=\"color: rgb(0, 32, 96);\"><em>IEEE/ACM Transactions on Networking</em></strong>, 2021, DOI:&nbsp;10.1109/TNET.2021.3113916.",
        "deploy_date": "",
        "id": 1,
        "number": "1"
    },
    {
        "content": "Tie Qiu, Jie Liu, Weisheng Si, Dapeng Oliver Wu. Robustness optimization scheme with multi-population co-evolution for scale-free wireless sensor networks. <strong style=\"color: rgb(0, 32, 96);\"><em>IEEE/ACM Transactions on Networking</em></strong>, 2019, vol. 27, no. 3, pp.&nbsp;1028-1042.&nbsp;<em>(</em><strong style=\"color: rgb(112, 48, 160);\"><em>ESI Highly Cited Paper</em></strong><em>)</em>",
        "deploy_date": "",
        "id": 2,
        "number": "2"
    },
    {
        "content": "Chen Chen, Lei Liu, Tie Qiu, Dapeng Oliver Wu, Zhiyuan Ren. Delay-aware grid-based geographic routing in urban VANETs: a backbone approach.<strong style=\"color: rgb(0, 32, 96);\"><em>&nbsp;IEEE/ACM Transactions on Networking</em></strong><em style=\"color: rgb(0, 32, 96);\">,</em>&nbsp;2019, vol. 27, no. 6, pp.&nbsp;2324-2337.",
        "deploy_date": "",
        "id": 3,
        "number": "3"
    },
    {
        "content": "Hui Xia, Rui Zhang, Xiangguo Cheng, Tie Qiu, Dapeng Oliver Wu. Two-stage game design of payoff decision-making scheme for crowdsourcing dilemma. <strong style=\"color: rgb(0, 32, 96);\"><em>IEEE/ACM Transactions on Networking</em></strong>, 2020, vol. 28, no. 6, pp.&nbsp;2741-2754.",
        "deploy_date": "",
        "id": 4,
        "number": "4"
    },
    {
        "content": "Tie Qiu, Aoyang Zhao, Feng Xia, Weisheng Si, Dapeng Oliver Wu. ROSE: Robustness strategy for scale-free wireless sensor networks. <strong style=\"color: rgb(0, 32, 96);\"><em>IEEE/ACM Transactions on Networking</em></strong>, 2017, vol. 25, no. 5, pp.&nbsp;2944-2959. <em>(</em><strong style=\"color: rgb(112, 48, 160);\"><em>ESI Highly Cited Paper</em></strong><em>)</em>",
        "deploy_date": "",
        "id": 5,
        "number": "5"
    },
    {
        "content": "Xiaoqiang Zhu, Tie Qiu, Wenyu Qu, Xiaobo Zhou, Mohammed Atiquzzaman, Dapeng Oliver Wu. BLS-Location: a wireless fingerprint localization algorithm based on broad learning.<strong style=\"color: rgb(0, 32, 96);\"><em>&nbsp;IEEE Transactions on Mobile Computing</em></strong><em style=\"color: rgb(0, 32, 96);\">,</em>&nbsp;2021, DOI:&nbsp;10.1109/TMC.2021.3073005.",
        "deploy_date": "",
        "id": 6,
        "number": "6"
    },
    {
        "content": "Xiaobo Zhou, Shuxin Ge, Tie Qiu, Keqiu Li, Mohammed Atiquzzaman. Energy-efficient service migration for multi-user heterogeneous dense cellular networks. <strong style=\"color: rgb(0, 32, 96);\"><em>IEEE Transactions on Mobile Computing</em></strong>, 2021, DOI:&nbsp;10.1109/TMC.2021.3087198.",
        "deploy_date": "",
        "id": 7,
        "number": "7"
    },
    {
        "content": "Xiaoqiang Zhu, Tie Qiu, Wenyu Qu, Xiaobo Zhou, Yifan Wang, Dapeng Oliver Wu. Path planning for adaptive CSI map construction with A3C in dynamic environments.&nbsp;<strong style=\"color: rgb(0, 32, 96);\"><em>IEEE Transactions on Mobile Computing</em></strong>, 2021, DOI:&nbsp;10.1109/TMC.2021.3131318.",
        "deploy_date": "",
        "id": 8,
        "number": "8"
    },
    {
        "content": "Tie Qiu, Ruixuan Qiao, Dapeng Oliver Wu. EABS: An event-aware backpressure scheduling scheme for emergency Internet of Things. <strong style=\"color: rgb(0, 32, 96);\"><em>IEEE Transactions on Mobile Computing</em></strong>, 2018, vol. 17, no. 1, pp.&nbsp;72-84. <em>(</em><strong style=\"color: rgb(112, 48, 160);\"><em>ESI Highly Cited Paper</em></strong><em>)</em>",
        "deploy_date": "",
        "id": 9,
        "number": "9"
    },
    {
        "content": "Chen Chen, Jinna Hu, Tie Qiu, Mohammed Atiquzzaman, Zhiyuan Ren. CVCG: Cooperative V2V-aided transmission scheme based on coalitional game for popular content distribution in vehicular ad-hoc networks.&nbsp;<strong style=\"color: rgb(0, 32, 96);\"><em>IEEE Transactions on Mobile Computing</em></strong>, 2019, vol. 18, no. 12, pp.&nbsp;2811-2828.",
        "deploy_date": "",
        "id": 10,
        "number": "10"
    }
];

export default data;